import { animated } from 'react-spring'
import styled from 'styled-components'

export { default as BaseWindow } from './BaseWindow'

export const PowerBtnWrapper = styled(animated.div)`
  position: absolute;
  transform-origin: top right;
  cursor: pointer;
`
